import { Component, OnInit } from '@angular/core';
import { UtilsServicesService } from './services/utils-services.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.sass'],
})
export class AppComponent implements OnInit {
  constructor( private  utilServices: UtilsServicesService) {
  }
  
  ngOnInit() {
    this.utilServices.getVersion()
  }
}
